// API pública de `@knowyourparcel/web` (ADR 0004 §8).
export {
  KypCapture,
  type KypCaptureOptions,
  type KypCaptureEventMap,
  type KypCaptureTestHooks,
  type StepDetail,
  type ProgressDetail,
  type CompleteDetail,
  type CaptureViewImage,
  type RejectedDetail,
  type ErrorDetail,
} from './capture.js';
export { KypCaptureElement, defineKypCaptureElement } from './ui/kyp-capture.js';
export {
  CameraGuard,
  isNativeFunction,
  matchesVirtualLabel,
  type GuardInput,
  type GuardResult,
  type GuardReason,
} from './CameraGuard.js';
export {
  SessionKeys,
  CAPTURE_CONTEXTS,
  requestMessage,
  shotMessage,
  videoMessage,
  bundleMessage,
  type CaptureSigner,
} from './SessionKeys.js';
export {
  FrameRing,
  VideoFrameSource,
  frameStats,
  type FrameSource,
  type SourceFrame,
  type Burst,
  type EncodedFrame,
} from './FrameRing.js';
export {
  HashChain,
  shotChainRoot,
  videoChainRoot,
  videoChainPrefixes,
  videoCheckpoints,
  VIDEO_SIGN_EVERY,
} from './HashChain.js';
export { deriveBurst, type BurstShape } from './burst.js';
export {
  ChallengeRunner,
  type ChallengeDisplay,
  type ChallengeOutcome,
  type MotionSource,
} from './ChallengeRunner.js';
export {
  GuidedCapture,
  assessQuality,
  STEP_PERCENT,
  type GuidedContext,
  type GuidedOutcome,
  type ShotKind,
} from './GuidedCapture.js';
export {
  VideoRecorder,
  MediaRecorderChunkSource,
  pickVideoMime,
  type ChunkSource,
  type RecordedChunk,
} from './VideoRecorder.js';
export { Uploader, type UploadProgress, type UploaderOptions } from './Uploader.js';
export { Telemetry } from './Telemetry.js';
export { CaptureClient, CaptureApiError, type FetchLike } from './client.js';
export { signBundle, buildShot, normalizeDeclarations } from './bundle.js';
export { createClock, type CaptureClock } from './clock.js';
export {
  browserEnvironment,
  isLocalApiBase,
  type CaptureEnvironment,
  type MediaDevicesLike,
  type EventSourceLike,
} from './environment.js';
export type { CaptureUI, Screen, UIAction, ViewName, RejectReason } from './screens.js';
export {
  sha256Hex,
  hmacSha256,
  canonicalize,
  contextMessage,
  dhashFromGray,
  dhashFromImageData,
  hamming,
  toHex,
  fromHex,
  u32,
  u64,
} from './crypto.js';
export { DICTIONARIES, translator, normalizeLocale, type MessageKey } from './i18n/index.js';
export { SDK_NAME, SDK_VERSION } from './version.js';
export type * from './types.js';

import { defineKypCaptureElement } from './ui/kyp-capture.js';

// Auto-registro de `<kyp-capture>` si hay `customElements` y la etiqueta está libre.
defineKypCaptureElement();
